'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var reactHookForm = require('react-hook-form');
var zod$1 = require('@hookform/resolvers/zod');
var zod = require('zod');
var utils = require('@chakra-ui/utils');
require('../../components/Input/InputFormatted.js');
var InputPassword = require('../../components/Input/InputPassword.js');
var Label = require('../../components/Label/Label.js');
require('../../components/Label/RequiredIndicator.js');
var FormError = require('../../components/FormError/FormError.js');
var Alert = require('../../components/Alert/Alert.js');
var AlertDescription = require('../../components/Alert/AlertDescription.js');
var AlertIcon = require('../../components/Alert/AlertIcon.js');
var AlertTitle = require('../../components/Alert/AlertTitle.js');
require('../../components/Alert/alertContext.js');
var Button = require('../../components/Button/Button.js');
require('../../components/Button/StatisticsButton.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var zod__namespace = /*#__PURE__*/_interopNamespace(zod);
var _excluded = ["onSubmit", "isInvalid", "isLoading", "labelProps", "inputProps", "translations", "className", "useFormProps"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Login form
 *
 * Renders our login form with validation.
 */
var LoginForm = function LoginForm(props) {
  var _t$email, _t$email$error, _t$email2, _t$email2$error, _t$password, _t$password$error, _t$error, _t$email3, _t$password2;
  var onSubmit = props.onSubmit,
    _props$isInvalid = props.isInvalid,
    isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    labelProps = props.labelProps,
    _props$inputProps = props.inputProps,
    inputProps = _props$inputProps === void 0 ? {
      variant: 'floating'
    } : _props$inputProps,
    t = props.translations,
    className = props.className,
    useFormProps = props.useFormProps,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var SCHEMA = zod__namespace.object({
    email: zod__namespace.string().nonempty({
      message: t === null || t === void 0 ? void 0 : (_t$email = t.email) === null || _t$email === void 0 ? void 0 : (_t$email$error = _t$email.error) === null || _t$email$error === void 0 ? void 0 : _t$email$error.required
    }).email({
      message: t === null || t === void 0 ? void 0 : (_t$email2 = t.email) === null || _t$email2 === void 0 ? void 0 : (_t$email2$error = _t$email2.error) === null || _t$email2$error === void 0 ? void 0 : _t$email2$error.email
    }),
    password: zod__namespace.string().nonempty({
      message: t === null || t === void 0 ? void 0 : (_t$password = t.password) === null || _t$password === void 0 ? void 0 : (_t$password$error = _t$password.error) === null || _t$password$error === void 0 ? void 0 : _t$password$error.required
    })
  });
  var form = reactHookForm.useForm(_objectSpread(_objectSpread({}, useFormProps), {}, {
    resolver: zod$1.zodResolver(SCHEMA)
  }));
  var register = form.register,
    handleSubmit = form.handleSubmit,
    errors = form.formState.errors;
  return /*#__PURE__*/React__default["default"].createElement(reactHookForm.FormProvider, form, isInvalid && /*#__PURE__*/React__default["default"].createElement(Alert.Alert, {
    mb: 5,
    status: "error"
  }, /*#__PURE__*/React__default["default"].createElement(AlertIcon.AlertIcon, null), /*#__PURE__*/React__default["default"].createElement(AlertDescription.AlertDescription, null, /*#__PURE__*/React__default["default"].createElement(AlertTitle.AlertTitle, null, t === null || t === void 0 ? void 0 : t.error.title), t === null || t === void 0 ? void 0 : (_t$error = t.error) === null || _t$error === void 0 ? void 0 : _t$error.text)), /*#__PURE__*/React__default["default"].createElement(react.chakra.form, _extends__default["default"]({
    className: utils.cx('chakra-login-form', className),
    noValidate: true,
    onSubmit: handleSubmit(onSubmit)
  }, rest), /*#__PURE__*/React__default["default"].createElement(react.FormControl, {
    id: "email",
    isInvalid: !!errors.email
  }, /*#__PURE__*/React__default["default"].createElement(Label.Label, labelProps, t === null || t === void 0 ? void 0 : (_t$email3 = t.email) === null || _t$email3 === void 0 ? void 0 : _t$email3.label), /*#__PURE__*/React__default["default"].createElement(react.Input, _extends__default["default"]({}, inputProps, {
    type: "email",
    autoComplete: "email",
    isInvalid: !!errors.email || isInvalid
  }, register('email'))), /*#__PURE__*/React__default["default"].createElement(FormError.FormError, null)), /*#__PURE__*/React__default["default"].createElement(react.FormControl, {
    id: "password",
    isInvalid: !!errors.password
  }, /*#__PURE__*/React__default["default"].createElement(Label.Label, labelProps, t === null || t === void 0 ? void 0 : (_t$password2 = t.password) === null || _t$password2 === void 0 ? void 0 : _t$password2.label), /*#__PURE__*/React__default["default"].createElement(InputPassword.InputPassword, _extends__default["default"]({}, inputProps, {
    isInvalid: !!errors.password || isInvalid
  }, register('password'))), /*#__PURE__*/React__default["default"].createElement(FormError.FormError, null)), /*#__PURE__*/React__default["default"].createElement(Button.Button, {
    w: "100%",
    isFloating: true,
    isLoading: isLoading,
    type: "submit"
  }, t === null || t === void 0 ? void 0 : t.submit)));
};
LoginForm.displayName = 'LoginForm';
exports.LoginForm = LoginForm;